import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LandscapeSvg = function LandscapeSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.864 9.649c0-1.33 1.063-2.409 2.373-2.409S18.61 8.32 18.61 9.65s-1.062 2.408-2.373 2.408c-1.31 0-2.373-1.078-2.373-2.408m2.373-1.033c-.561 0-1.017.463-1.017 1.033s.456 1.032 1.017 1.032c.562 0 1.017-.462 1.017-1.032s-.455-1.033-1.017-1.033",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 4h20v16H2zm1.356 11.959v2.665h14.107l-3.002-3.048-1.957 1.986-5.364-5.444zm0-1.947 3.784-3.84 5.364 5.444 1.957-1.986 4.92 4.994h1.263V5.376H3.356z",
    clipRule: "evenodd"
  }));
};
export var Landscape = function Landscape(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LandscapeSvg
  }));
};